import React from 'react';
import SectionState from './SectionState';
import Sparkline from './charts/Sparkline';
import { levelTone, plural } from './lib/activityFormat';

const MAX_LEVEL = 5;

const firstAndLast = (levels) => {
  const known = levels.filter((v) => v != null);
  return known.length ? [known[0], known[known.length - 1]] : [null, null];
};

const trendsTitle = (count) => {
  if (count > 1) return `TARA traits over the last ${count} essays`;
  return count === 1 ? 'TARA traits in the latest essay' : 'TARA traits';
};

const TraitCard = ({ trait, essays }) => {
  const [first, last] = firstAndLast(trait.levels);
  const levels = trait.levels.map((v) => (v == null ? 'not marked' : v)).join(', ');
  let caption = 'Not marked';
  if (last != null) caption = essays > 1 ? `Level ${first} → ${last} of 5` : `Level ${last} of 5`;
  return (
    <div className="td-act-spark-card">
      <div className="td-act-spark-card__name">{trait.label}</div>
      <Sparkline
        values={trait.levels}
        max={MAX_LEVEL}
        tone={levelTone(last, MAX_LEVEL)}
        label={`${trait.label}: level ${levels} over the last ${plural(essays, 'essay')}, oldest first`}
      />
      <div className="td-act-spark-card__caption">{caption}</div>
    </div>
  );
};

/**
 * TARA trait levels over the student's latest essays, from
 * GET …/activity/writing/trait-trends: a sparkline per trait, in rubric order.
 * It covers the latest essays whatever period is chosen.
 */
const TraitTrends = ({ state }) => {
  const data = state.status === 'ready' ? state.data : null;
  const count = data ? data.essays.length : 0;
  return (
    <div className="td-card td-act-gap">
      <h4 className="td-card__title">
        {trendsTitle(count)}
      </h4>
      <SectionState state={state} what="trait trends" emptyTitle="No marked TARA essays yet" />
      {data ? (
        <div className="td-act-trend">
          {data.traits.map((t) => <TraitCard key={t.key} trait={t} essays={count} />)}
        </div>
      ) : null}
    </div>
  );
};

export default TraitTrends;
